import React from 'react';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { useGlobalLocale } from '@gov-nx/core/service';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const MyAuthorizationListSkeleton = () => {
	const { t } = useGlobalLocale();

	return (
		<>
			{Array.from(Array(2))
				.fill(null)
				.map((_, index) => {
					const randomNumber = generateRandomNumber(40, 70);
					return (
						<div // eslint-disable-next-line react/no-array-index-key
							key={index}
							className="flex justify-between items-center p-6 mt-0!">
							<div
								className="flex items-center"
								style={{ width: randomNumber + '%' }}>
								<GovSkeleton
									width="100%"
									height="24px"
									aria-label={t('loading.wcag.processing')}
								/>
							</div>
							<div className="flex gap-4">
								<GovSkeleton
									width="80px"
									height="20px"
									aria-label={t('loading.wcag.processing')}
									className="mt-4 [ md:ml-auto md:mt-0 ]"
								/>
								<GovSkeleton
									width="20px"
									height="20px"
									aria-label={t('loading.wcag.processing')}
									className="hidden [ md:block md:ml-3 ]"
								/>
							</div>
						</div>
					);
				})}
		</>
	);
};
